module.exports = __webpack_public_path__ + "static/media/DSC_0230.8fe8a7bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0230.jpg
// module id = 650
// module chunks = 0